import { useContext } from 'react';

import {
    createAutocompleteActionContext,
    createAutocompleteProvider,
    createAutocompleteStateContext,
} from 'component/Layout/Autocomplete';

import { AutocompleterGroup, DestinationEntry } from '../types';

const DestinationAutocompleterContext =
    createAutocompleteStateContext<AutocompleterGroup, DestinationEntry>();
DestinationAutocompleterContext.displayName = 'DestinationAutocompleterContext';
const DestinationAutocompleterActionContext =
    createAutocompleteActionContext<AutocompleterGroup, DestinationEntry>();
DestinationAutocompleterActionContext.displayName =
    'DestinationAutocompleterActionContext';

const DestinationProvider = createAutocompleteProvider(
    DestinationAutocompleterContext,
    DestinationAutocompleterActionContext
);

export const useDestinationAutocompleterState = () =>
    useContext(DestinationAutocompleterContext);

export const useDestinationAutocompleterAction = () =>
    useContext(DestinationAutocompleterActionContext);

export default DestinationProvider;
